// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__poSZi","title":"styles_title__2JYzZ"};